import React, { Component, Fragment } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import moment from 'moment';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import _ from 'lodash';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import { TabEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import { LoadingPage, DirtyWrapper, YesNoDialog } from 'Components';
import { ImportItemsContainer } from './importInventory/containers/ImportItems';
import { ExportItemsContainer } from './exportInventory/containers/ExportItems';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  FILE_DELIMITER_MAP,
} from 'Common/Constants';
import { ImportExportTypeOptionsEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import {
  IMPORT_ITEMS_FORM_NAME,
  EXPORT_ITEMS_FORM_NAME,
} from 'Common/FormEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import {
  errorToast,
  createToast,
  toastType,
  toastSuccess,
  toastError,
} from 'Common/ToastHelper';
import 'Styles/pages/utilities/importexportinventory/index.less';
import { Filter, Main } from 'Containers';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { resetDirty } from 'State/dirtyTracking/actions';

import {
  getColumns,
  getExistingExportConfig,
  saveExport,
  importFormItemsData,
  clearImportItemsData,
  getExistingImportConfig,
  deleteExportImport,
  clearErrorMsgs,
  setImportType,
  setExportType,
  addColumnMapping,
} from './../state/importExport/actions';
import {
  getColumnMappingOptions,
  getColumnOptions,
  validateMandatoryColumn,
} from './../helper/importExport';
import * as Selectors from './../state/importExport/selector';

class ImportExportInventoryContainer extends Component {
  static propTypes = {
    importType: PropTypes.number,
    importDelimiter: PropTypes.string,
    importIncludeHeaders: PropTypes.bool,
    importBidPrice: PropTypes.bool,
    importBeginDT: PropTypes.string,
    importEndDT: PropTypes.string,
    importName: PropTypes.string,
    importId: PropTypes.number,
    exportType: PropTypes.number,
    loadPrevious: PropTypes.number,
    importItemsLoading: PropTypes.bool.isRequired,
    fetchExistingExportConfigLoading: PropTypes.bool.isRequired,
    fetchColumnsLoading: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    existingExportConfig: PropTypes.array.isRequired,
    exportLoadPrevious: PropTypes.number,
    columnMapping: PropTypes.array.isRequired,
    importItemsDataLoading: PropTypes.bool.isRequired,
    fetchColumnsLoadingError: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    fetchExistingExportConfigLoadingError: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    importItemsDataLoadingError: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    deleteConfigLoading: PropTypes.bool.isRequired,
    deleteConfigLoadingError: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    deleteConfigData: PropTypes.object,
    columns: PropTypes.array.isRequired,
    configurationName: PropTypes.string,
    submitted: PropTypes.bool.isRequired,
    importItemsData: PropTypes.object,
    loadPreviousImportOptionsDropDown: PropTypes.array.isRequired,
    loadPreviousOptionsDropDown: PropTypes.array.isRequired,
    importItems: PropTypes.object.isRequired,
    isFileEmpty: PropTypes.bool.isRequired,
    onlyOneItemPresent: PropTypes.bool.isRequired,
    exportColumnItems: PropTypes.array.isRequired,
  };
  static defaultProps = {
    importType: ImportExportTypeOptionsEnum.OneTimeOnly,
    importDelimiter: FILE_DELIMITER_MAP.COMMA.value,
    importIncludeHeaders: false,
    importBidPrice: true,
    importBeginDT: '',
    importEndDT: '',
    importName: '',
    importId: 0,
    exportType: ImportExportTypeOptionsEnum.OneTimeOnly,
    loadPrevious: 0,
    exportLoadPrevious: 0,
    configurationName: '',
    submitError: null,
    fetchColumnsLoadingError: null,
    fetchExistingExportConfigLoadingError: null,
    importItemsDataLoadingError: null,
    deleteConfigLoadingError: null,
    importItemsData: null,
    deleteConfigData: null,
  };
  state = {
    headerInfo: TabEnum.Import,
    allChipsData: [],
    selectedChipsData: [],
    file: null,
    showSaveModal: false,
    showDeleteModal: false,
    showImportSaveModal: false,
    isDirty: false,
  };
  headerRowButtons = [
    { title: 'Import items', value: TabEnum.Import },
    {
      title: 'Export items',
      value: TabEnum.Export,
    },
  ];
  componentDidMount() {
    this.props.getExistingExportConfig();
    this.props.getExistingImportConfig();
    this.props.getColumns().then(() => {
      this.setState({ allChipsData: this.props.exportColumnItems });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      importItemsData,
      deleteConfigData,
      submitted,
      isFileEmpty,
      onlyOneItemPresent,
      clearErrorMsgs,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'fetchColumnsLoadingError') ||
      errorToast(
        this.props,
        prevProps,
        'fetchExistingExportConfigLoadingError'
      ) ||
      errorToast(this.props, prevProps, 'importItemsDataLoadingError') ||
      errorToast(this.props, prevProps, 'deleteConfigLoadingError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearErrorMsgs();
    } else if (submitted && !prevProps.submitted) {
      this.state.headerInfo === TabEnum.Import
        ? createToast(
            toastType.success,
            'Success',
            'Import settings saved successfully.',
            true
          )
        : createToast(
            toastType.success,
            'Success',
            'Export completed successfully',
            true
          );
      clearErrorMsgs();
      this.props.resetDirty();
    }
    if (
      _.has(deleteConfigData, 'Data.Message') &&
      deleteConfigData.Data.Message
    ) {
      toastSuccess(deleteConfigData.Data.Message);
      clearErrorMsgs();
    } else if (
      _.has(importItemsData, 'Data.Message') &&
      importItemsData.Data.Message &&
      prevProps.importItemsData !== importItemsData
    ) {
      toastSuccess(importItemsData.Data.Message);
      clearErrorMsgs();
    } else if (isFileEmpty && !prevProps.isFileEmpty) {
      toastError('File is empty');
      clearErrorMsgs();
    } else if (onlyOneItemPresent && !prevProps.onlyOneItemPresent) {
      toastError('The Import File should have at least 2 row(s)');
      clearErrorMsgs();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  onImportClick = result => {
    const {
      importFormItemsData,
      columnMapping,
      importType,
      importDelimiter,
      importIncludeHeaders,
      importBidPrice,
      importBeginDT,
      importEndDT,
      importName,
      importId,
    } = this.props;
    const config = {
      [ImportExportItemsEnum.Delimiter]: importDelimiter,
      [ImportExportItemsEnum.IncludeHeaders]: importIncludeHeaders,
      [ImportExportItemsEnum.IncludeBidPrice]: importBidPrice,
      [ImportExportItemsEnum.BeginDT]: importBidPrice
        ? moment(importBeginDT).format(DATE_FORMAT_FOR_SERVER)
        : null,
      [ImportExportItemsEnum.EndDT]: importBidPrice
        ? moment(importEndDT).format(DATE_FORMAT_FOR_SERVER)
        : null,
      [ImportExportItemsEnum.SelectedFields]: columnMapping,
      [ImportExportItemsEnum.Operation]: false,
      [ImportExportItemsEnum.Name]: importName,
      [ImportExportItemsEnum.Type]: importType,
      [ImportExportItemsEnum.Id]:
        importType === ImportExportTypeOptionsEnum.LoadPreviouslySaved
          ? importId
          : 0,
    };
    if (!this.validateImportColumnMapping() && this.state.file) {
      try {
        const formData = new FormData();
        formData.append('FieldConfig', JSON.stringify(config));
        formData.append('import_file', this.state.file);
        importFormItemsData(formData).then(() => {
          if (result) {
            this.onSaveClick();
          }
        });
      } catch (e) {}
    }
    this.setState({ showImportSaveModal: false });
  };
  handleImportClick = () => {
    const { importType } = this.props;
    if (
      (importType === ImportExportTypeOptionsEnum.LoadPreviouslySaved &&
        this.state.isDirty) ||
      importType === ImportExportTypeOptionsEnum.New
    ) {
      this.setState({ showImportSaveModal: true });
    } else {
      this.onImportClick(true);
    }
  };
  validateImportColumnMapping = () => {
    const { columnMapping, importBidPrice } = this.props;
    const manColNames = validateMandatoryColumn(columnMapping, importBidPrice);
    let notValid = !!manColNames.length;
    if (manColNames.length) {
      createToast(
        toastType.error,
        'The following fields required for import are missing\t',
        _.map(manColNames, colName => {
          return `\n${colName[ImportExportItemsEnum.ColLabel]}`;
        }),
        false
      );
    } else if (!importBidPrice && columnMapping.length < 2) {
      createToast(
        toastType.error,
        "Importing without updating bid prices requires 'Item Code' and at least one other column to be mapped.",
        false
      );
      notValid = true;
    }
    return notValid;
  };
  handleDialog = result => {
    if (result) {
      this.state.headerInfo === TabEnum.Import
        ? this.onSaveClick()
        : this.onSaveExportClick();
    }
    this.setState({ showSaveModal: false });
  };
  onSaveClick = () => {
    this.setState({ isDirty: false });
    this.props.submitForm(IMPORT_ITEMS_FORM_NAME);
  };
  onSaveExportClick = () => {
    this.props.submitForm(EXPORT_ITEMS_FORM_NAME);
  };
  handleExportSave = values => {
    const model = { ...values };
    delete model.LoadPrevious;
    const { selectedChipsData } = this.state;
    if (!selectedChipsData.length || selectedChipsData.length < 2) {
      toastError('Please select at least 2 fields for export');
      return;
    }
    const { loadPreviousOptionsDropDown } = this.props;
    let name = '';
    if (
      values[ImportExportItemsEnum.Type] ===
      ImportExportTypeOptionsEnum.LoadPreviouslySaved
    ) {
      const obj = _.find(loadPreviousOptionsDropDown, [
        'value',
        values[ImportExportItemsEnum.LoadPrevious],
      ]);
      if (obj) {
        name = obj.text;
      }
    } else {
      name = values[ImportExportItemsEnum.Name];
    }

    this.props.saveExport({
      ...model,
      SelectedFields: _.map(selectedChipsData, item => item.ColName).join(),
      [ImportExportItemsEnum.Operation]: true,
      [ImportExportItemsEnum.Name]: name,
      [ImportExportItemsEnum.Id]:
        values[ImportExportItemsEnum.Type] ===
        ImportExportTypeOptionsEnum.LoadPreviouslySaved
          ? values[ImportExportItemsEnum.LoadPrevious]
          : 0,
    });
  };
  handleImportSave = values => {
    const { loadPreviousImportOptionsDropDown } = this.props;
    let name = '';
    if (
      values[ImportExportItemsEnum.Type] ===
      ImportExportTypeOptionsEnum.LoadPreviouslySaved
    ) {
      const obj = _.find(loadPreviousImportOptionsDropDown, [
        'value',
        values[ImportExportItemsEnum.LoadPrevious],
      ]);
      if (obj) {
        name = obj.text;
      }
    } else {
      name = values[ImportExportItemsEnum.Name];
    }

    if (
      values[ImportExportItemsEnum.Type] !==
      ImportExportTypeOptionsEnum.OneTimeOnly
    ) {
      const config = {
        [ImportExportItemsEnum.Delimiter]:
          values[ImportExportItemsEnum.Delimiter],
        [ImportExportItemsEnum.IncludeHeaders]:
          values[ImportExportItemsEnum.IncludeHeaders],
        [ImportExportItemsEnum.ImportBidPrice]:
          values[ImportExportItemsEnum.ImportBidPrice],
        [ImportExportItemsEnum.BeginDT]: values[
          ImportExportItemsEnum.ImportBidPrice
        ]
          ? moment(values[ImportExportItemsEnum.BeginDT]).format(
              DATE_FORMAT_FOR_SERVER
            )
          : null,
        [ImportExportItemsEnum.EndDT]: values[
          ImportExportItemsEnum.ImportBidPrice
        ]
          ? moment(values[ImportExportItemsEnum.EndDT]).format(
              DATE_FORMAT_FOR_SERVER
            )
          : null,
        [ImportExportItemsEnum.SelectedFields]: JSON.stringify(
          this.props.columnMapping
        ),
        [ImportExportItemsEnum.Operation]: false,
        [ImportExportItemsEnum.Name]: name,
        [ImportExportItemsEnum.Type]: values[ImportExportItemsEnum.Type],
        [ImportExportItemsEnum.Id]:
          values[ImportExportItemsEnum.Type] ===
          ImportExportTypeOptionsEnum.LoadPreviouslySaved
            ? values[ImportExportItemsEnum.LoadPrevious]
            : 0,
      };
      !this.validateImportColumnMapping() && this.props.saveExport(config);
    }
  };
  onDeleteClick = () => {
    const { headerInfo } = this.state;
    const {
      importId,
      exportLoadPrevious,
      loadPreviousOptionsDropDown,
      loadPreviousImportOptionsDropDown,
      deleteExportImport,
      setImportType,
      setExportType,
      resetForm,
      addColumnMapping,
      exportColumnItems,
    } = this.props;
    if (headerInfo === TabEnum.Import) {
      const configObj = _.find(loadPreviousImportOptionsDropDown, [
        'value',
        importId,
      ]);
      configObj &&
        deleteExportImport(configObj.value).then(() => {
          this.props.getExistingImportConfig();
          resetForm(IMPORT_ITEMS_FORM_NAME);
          this.setState({ file: null });
          setImportType();
          addColumnMapping([]);
        });
    } else {
      const configObj = _.find(loadPreviousOptionsDropDown, [
        'value',
        exportLoadPrevious,
      ]);
      configObj &&
        deleteExportImport(configObj.value).then(() => {
          this.props.getExistingExportConfig();
          resetForm(EXPORT_ITEMS_FORM_NAME);
          setExportType();
          this.setState({
            allChipsData: exportColumnItems,
            selectedChipsData: [],
          });
        });
    }
  };

  onClearClick = () => {
    const { resetForm, clearImportItemsData, exportColumnItems } = this.props;
    const { headerInfo } = this.state;
    if (headerInfo === TabEnum.Import) {
      resetForm(IMPORT_ITEMS_FORM_NAME);
      this.setState({ file: null });
      clearImportItemsData();
    } else {
      resetForm(EXPORT_ITEMS_FORM_NAME);
      this.setState({
        allChipsData: exportColumnItems,
        selectedChipsData: [],
      });
    }
  };
  setFile = file => {
    this.setState({ file });
  };
  handleDeleteDialog = result => {
    if (result) {
      this.onDeleteClick();
    }
    this.setState({ showDeleteModal: false });
  };
  handleDeleteClick = () => {
    this.setState({ showDeleteModal: true });
  };
  handleSaveClick = () => {
    if (
      this.state.headerInfo === TabEnum.Export &&
      ImportExportTypeOptionsEnum.OneTimeOnly === this.props.exportType
    ) {
      this.onSaveExportClick();
    } else {
      this.setState({ showSaveModal: true });
    }
  };
  getMainProps = showDirtyConfirm => {
    const { headerInfo } = this.state;
    const {
      importType,
      exportType,
      loadPrevious,
      exportLoadPrevious,
      configurationName,
    } = this.props;
    let toolbox = {
      backButtonProps: {},
      rightButtons: [],
      shown: true,
    };

    toolbox.rightButtons = [
      {
        content: 'Import',
        onClick: this.handleImportClick,
        disabled: !this.state.file,
      },
      {
        content: 'Save',
        onClick: this.handleSaveClick,
        disabled: importType === ImportExportTypeOptionsEnum.OneTimeOnly,
      },
      {
        content: 'Delete',
        onClick: this.handleDeleteClick,
        disabled:
          importType !== ImportExportTypeOptionsEnum.LoadPreviouslySaved ||
          !loadPrevious,
      },
      {
        content: 'Clear',
        onClick: this.onClearClick,
      },
    ];
    if (headerInfo === TabEnum.Export) {
      toolbox.rightButtons = [
        {
          content: 'Save/Export',
          onClick: this.handleSaveClick,
          disabled:
            (exportType === ImportExportTypeOptionsEnum.LoadPreviouslySaved &&
              !exportLoadPrevious) ||
            (exportType === ImportExportTypeOptionsEnum.New &&
              !configurationName),
        },
        {
          content: 'Delete',
          onClick: this.handleDeleteClick,
          disabled:
            exportType !== ImportExportTypeOptionsEnum.LoadPreviouslySaved ||
            !exportLoadPrevious,
        },
        {
          content: 'Clear',
          onClick: this.onClearClick,
        },
      ];
    }
    return {
      toolbox,
    };
  };
  setStateChipsData = (allChipsData, selectedChipsData) => {
    this.setState({
      allChipsData,
      selectedChipsData,
    });
  };
  setIsDirty = isDirty => {
    this.setState({ isDirty });
  };
  render() {
    const {
      headerInfo,
      showDeleteModal,
      showSaveModal,
      showImportSaveModal,
    } = this.state;
    const {
      isReadOnly,
      importItemsLoading,
      fetchExistingExportConfigLoading,
      fetchColumnsLoading,
      submitting,
      importItemsDataLoading,
      deleteConfigLoading,
      exportType,
      exportColumnItems,
      columnMapping
    } = this.props;
    const title = `Inventory ${
      headerInfo === TabEnum.Import ? 'Import' : 'Export'
    }`;
    const question =
      showSaveModal || showImportSaveModal
        ? 'Save Changes?'
        : 'Are you sure you want to delete the saved config?';
    return importItemsLoading ||
      fetchExistingExportConfigLoading ||
      fetchColumnsLoading ? (
      <LoadingPage />
    ) : submitting ? (
      <LoadingPage message={'Saving'} />
    ) : importItemsDataLoading ? (
      <LoadingPage message={'Importing'} />
    ) : deleteConfigLoading ? (
      <LoadingPage message={'Deleting'} />
    ) : (
      <Fragment>
        <Filter title={'Import/Export'} newRow={true}>
          <Grid>
            <Grid.Row column={1}>
              <Grid.Column width={12}>
                <Button.Group basic className="btn-group--active-group">
                  {this.headerRowButtons.map(button => (
                    <Button
                      key={button.title}
                      basic
                      className="white"
                      active={headerInfo === button.value}
                      onClick={() =>
                        this.setState({
                          headerInfo: button.value,
                        })
                      }
                      type={'button'}
                    >
                      {button.title}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {headerInfo === TabEnum.Import && (
                <ImportItemsContainer
                  initialValues={{
                    [ImportExportItemsEnum.Type]:
                      ImportExportTypeOptionsEnum.OneTimeOnly,
                    [ImportExportItemsEnum.ImportBidPrice]: true,
                    [ImportExportItemsEnum.BeginDT]: moment().format(
                      DATE_FORMAT_FOR_UI
                    ),
                    [ImportExportItemsEnum.EndDT]: moment().format(
                      DATE_FORMAT_FOR_UI
                    ),
                    [ImportExportItemsEnum.FileFormat]: 'delimiter',
                    [ImportExportItemsEnum.Delimiter]:
                      FILE_DELIMITER_MAP.COMMA.value,
                    [ImportExportItemsEnum.IncludeHeaders]: true,
                  }}
                  setFile={this.setFile}
                  file={this.state.file}
                  onSubmit={this.handleImportSave}
                  columnMapping={columnMapping}
                  setIsDirty={this.setIsDirty}
                />
              )}
              {headerInfo === TabEnum.Export && (
                <ExportItemsContainer
                  initialValues={{
                    [ImportExportItemsEnum.Type]: exportType
                      ? exportType
                      : ImportExportTypeOptionsEnum.OneTimeOnly,
                    [ImportExportItemsEnum.IncludeWOCurrentBidPrice]: true,
                    [ImportExportItemsEnum.Delimiter]:
                      FILE_DELIMITER_MAP.COMMA.value,
                    [ImportExportItemsEnum.IncludeHeaders]: true,
                  }}
                  setStateChipsData={this.setStateChipsData}
                  selectedChipsData={this.state.selectedChipsData}
                  allChipsData={this.state.allChipsData}
                  onSubmit={this.handleExportSave}
                  columns={exportColumnItems}
                />
              )}
            </Main>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={showSaveModal || showDeleteModal || showImportSaveModal}
          title={title}
          question={question}
          yesCallback={() => {
            showSaveModal
              ? this.handleDialog(true)
              : showImportSaveModal
              ? this.onImportClick(true)
              : this.handleDeleteDialog(true);
          }}
          noCallback={() => {
            showSaveModal
              ? this.handleDialog(false)
              : showImportSaveModal
              ? this.onImportClick(false)
              : this.handleDeleteDialog(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(IMPORT_ITEMS_FORM_NAME);
const exportSelector = formValueSelector(EXPORT_ITEMS_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(IMPORT_ITEMS_FORM_NAME)(state));
  ownProps.setPageLevelDirty(getIsDirty(EXPORT_ITEMS_FORM_NAME)(state));
  const { importExport } = state.UtilitiesState;
  const { columns } = importExport;
  const importBidPrice = selector(state, ImportExportItemsEnum.ImportBidPrice);
  return {
    importType: selector(state, ImportExportItemsEnum.Type),
    importDelimiter: selector(state, ImportExportItemsEnum.Delimiter),
    importIncludeHeaders: selector(state, ImportExportItemsEnum.IncludeHeaders),
    importBidPrice,
    importBeginDT: selector(state, ImportExportItemsEnum.BeginDT),
    importEndDT: selector(state, ImportExportItemsEnum.EndDT),
    importName: selector(state, ImportExportItemsEnum.Name),
    importId: selector(state, ImportExportItemsEnum.LoadPrevious),
    exportType: exportSelector(state, ImportExportItemsEnum.Type),
    loadPrevious: selector(state, ImportExportItemsEnum.LoadPrevious),
    importItemsLoading: Selectors.getImportItemsLoading(state),
    fetchExistingExportConfigLoading: Selectors.getExistingExportConfigLoading(
      state
    ),
    fetchColumnsLoading: Selectors.getColumnsLoading(state),
    submitting: Selectors.isSubmitting(state),
    submitError: Selectors.getSubmitError(state),
    existingExportConfig: Selectors.getExistingExportConfig(state),
    exportLoadPrevious: exportSelector(
      state,
      ImportExportItemsEnum.LoadPrevious
    ),
    columnMapping: getColumnMappingOptions(
      Selectors.getColumnMapping(state),
      getColumnOptions(columns, importBidPrice)
    ),
    importItemsDataLoading: Selectors.getImportItemsDataLoading(state),
    fetchColumnsLoadingError: Selectors.getColumnsLoadingError(state),
    fetchExistingExportConfigLoadingError: Selectors.getExistingExportConfigLoadingError(
      state
    ),
    importItemsDataLoadingError: Selectors.getImportItemsDataLoadingError(
      state
    ),
    deleteConfigLoading: Selectors.getDeleteConfigLoading(state),
    deleteConfigLoadingError: Selectors.getDeleteConfigLoadingError(state),
    deleteConfigData: Selectors.getDeleteConfigData(state),
    columns: Selectors.getColumns(state),
    configurationName: exportSelector(state, ImportExportItemsEnum.Name),
    submitted: Selectors.isSubmitted(state),
    importItemsData: Selectors.getImportItemsData(state),
    loadPreviousImportOptionsDropDown: Selectors.getLoadPreviousImportOptionsDropDown(
      state
    ),
    loadPreviousOptionsDropDown: Selectors.getLoadPreviousOptionsDropDown(
      state
    ),
    importItems: Selectors.getImportItems(state),
    isFileEmpty: Selectors.isFileEmpty(state),
    onlyOneItemPresent: Selectors.isOnlyOneItemPresent(state),
    exportColumnItems: Selectors.getExportColumns(state),
  };
};

const mapDispatchToProps = {
  getExistingExportConfig,
  getColumns,
  saveExport,
  submitForm,
  resetForm,
  importFormItemsData,
  clearImportItemsData,
  getExistingImportConfig,
  deleteExportImport,
  clearErrorMsgs,
  setImportType,
  setExportType,
  addColumnMapping,
  resetDirty,
};
export const ImportExportInventory = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportExportInventoryContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/ImportExportInventory.js